import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { catchError } from 'rxjs/operators';
import { environment } from '../../shared/config/app-config';
import { JwtService } from './jwt.service';

@Injectable()
export class ApiService {
  constructor(
    private router: Router,
    private http: HttpClient,
    private jwtService: JwtService
  ) { }

  private setHeaders(): HttpHeaders {
    const headersConfig = {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    };
    if (this.jwtService.getToken()) {
      headersConfig['Authorization'] = `${this.jwtService.getToken()}`;
    }
      headersConfig['_lang'] = localStorage.getItem("selectedLanguage") && localStorage.getItem("selectedLanguage") != 'null'  ? localStorage.getItem("selectedLanguage") : "en";
    return new HttpHeaders(headersConfig);
  }
  private setSHeaders(): HttpHeaders {
    const headersConfig = {
      //'Content-Type': 'application/json',
      //'Accept': 'application/json'
    };
    if (this.jwtService.getToken()) {
      headersConfig['Authorization'] = `${this.jwtService.getToken()}`;
    }
      headersConfig['_lang'] = localStorage.getItem("selectedLanguage") && localStorage.getItem("selectedLanguage") != 'null'  ? localStorage.getItem("selectedLanguage") : "en";
    return new HttpHeaders(headersConfig);
  }
  private setHeadersimg(): HttpHeaders {
    const headersConfig = {
      // 'Content-Type': 'application/json',
      'Accept': 'application/json'
    };
    if (this.jwtService.getToken()) {
      headersConfig['Authorization'] = `${this.jwtService.getToken()}`;
    }
      headersConfig['_lang'] = localStorage.getItem("selectedLanguage") && localStorage.getItem("selectedLanguage") != 'null'  ? localStorage.getItem("selectedLanguage") : "en";
    return new HttpHeaders(headersConfig);
  }
  private setServletHeaders(): HttpHeaders {
    const headersConfig = {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": " GET, POST, OPTIONS",
      "Access-Control-Allow-Headers": "Content-Type",
      "Access-Control-Allow-Credentials": "true"
    };
    return new HttpHeaders(headersConfig);
  }

  private formatErrors(error: any) {
    if ((error.status == 404 || error.status == 401) && window.localStorage['jwtToken']) {
      if (window.localStorage['plogin']) {
        this.router.navigateByUrl(`/plogin/${window.localStorage['plogin']}`)
      }
      else {
        this.router.navigateByUrl(`/login`)
      }
    }
    return throwError(error?.error);
  }

  get(path: string): Observable<any> {
    return this.http.get(`${environment.api_url}${path}`, { headers: this.setHeaders() })
      .catch(this.formatErrors);
  }

  getHTML(path: string): Observable<any> {
    return this.http.get(`${path}`, { responseType: 'text' })
      .catch(this.formatErrors);
  }

  servletget(path: string): Observable<any> {
    return this.http.get(`${environment.api_url}${path}`, { headers: new HttpHeaders() })
      .catch(this.formatErrors);
  }
  
  postpdf(path: string, body: Object = {}): Observable<any> {
    return this.http.post(`${environment.api_url}${path}`, JSON.stringify(body), { headers: this.setSHeaders(), responseType: 'text' })
      .catch(this.formatErrors);
  }

  put(path: string, body: Object = {}): Observable<any> {
    return this.http.put(
      `${environment.api_url}${path}`,
      JSON.stringify(body),
      { headers: this.setHeaders() }
    ).catch(this.formatErrors);
  }

  post(path: string, body: Object = {}): Observable<any> {
    return this.http.post(`${environment.api_url}${path}`, JSON.stringify(body), { headers: this.setHeaders() })
      .catch(this.formatErrors);
  }

  normalpost(path: string, body: Object = {}): Observable<any> {
    return this.http.post(`${environment.api_url}${path}`, {})
      .catch(this.formatErrors);
  }

  servletpost(path: string, body: Object = {}): Observable<any> {
    return this.http.post(`${environment.api_url}${path}`, JSON.stringify(body), { headers: new HttpHeaders() })
      .catch(this.formatErrors);
  }

  imagepost(path: string, body: any) {
    return this.http.post(
      `${environment.api_url}${path}`,
      body,
      { headers: this.setHeadersimg() }
    ).catch(this.formatErrors);

  }

  delete(path): Observable<any> {
    return this.http.delete(
      `${environment.api_url}${path}`,
      { headers: this.setHeadersimg() }
    ).catch(this.formatErrors);
  }

  fileupload(path: string, body: any): Observable<any> {
    // let options = new RequestOptions({ headers: this.setHeadersimg() });
    return this.http.post(
      `${environment.api_url}${path}`,
      body,
      { headers: this.setHeadersimg() }
    ).catch(this.formatErrors);
  }

  // multipart file upload
  multipartFileUpload(path: string, body: any): Observable<any> {
    return this.http.post(`${environment.api_url}${path}`, body, { headers: this.getFileDataHeader() })
      .pipe(catchError(this.formatErrors));
  }


  private getFileDataHeader(): HttpHeaders {
    const headersConfig: any = {}
    if (this.jwtService.getToken()) {
      headersConfig['Authorization'] = `${'Bearer '}${this.jwtService.getToken()}`;
    }
      headersConfig['_lang'] = localStorage.getItem("selectedLanguage") && localStorage.getItem("selectedLanguage") != 'null'  ? localStorage.getItem("selectedLanguage") : "en";
    return new HttpHeaders(headersConfig);
  }

}
